import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=45f967e9"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports